import { SvgIconDefinition } from '@am/icons-common-types';
import { aciTv } from '@am/common-svg-icons';

export const aciTelevision: SvgIconDefinition = {
  ...aciTv,
  iconName: 'television',
};
